import {ChangeDetectionStrategy, Component, Inject, OnInit} from "@angular/core";
import {OnDestroy$} from "@pdtec/ngx-observable-lifecycle";
import {
  HotelPriceCalendarComponent
} from "../../components/hotel-tours/short-search-params/calendar/calendar.component";
import {HotelToursSearchService} from "../../services/search/hotel-tours-search.service";
import {WindowRefService} from "../../services/window-ref.service";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../config/hotel-tours-list-page.config";

@Component({
  selector: 'page-manager-offer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<app-hotel-price-calendar/>',
  imports: [
    HotelPriceCalendarComponent
  ],
  standalone: true
})
export class PageManagerOfferComponent extends OnDestroy$ implements OnInit {
  constructor(
    private hotelToursSearchService: HotelToursSearchService,
    private windowService: WindowRefService,
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
  ) {
    super();
  }
  ngOnInit(): void {
    this.windowService.nativeWindow.lastSearchParams = this.hotelToursPageConfig.searchFormValues;
    this.hotelToursSearchService.setLastSearchParams(this.hotelToursPageConfig.searchFormValues);
  }
}
